<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/k0fmJ3/media/FC-9781035835485.jpg?1718732527196" alt="This image is the cover for the book Sleep with the Holy Ghost"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sleep with the Holy Ghost
      </h1>
      <p class="bookDescription body article font2">
        <p>“Do you think, Sir, that Ireland should have joined the war against Germany?” “I mean, Sir, that the married women in Ireland, like me Ma, and lots of other fellas’ mothers have loads of babies and are always having to go into hospital to have them or have to feed them and wash them.  The mothers have stacks of work to do all the time and they’re always carrying babies around in their bellies or in their arms.” Patsy Fagan, growing up in Dublin in the 1950s, asks awkward questions of his schoolteacher, Mr Bambrick. A reflective memoir that touches on the impact of history, war, death of a young sister, religion, and schooling on the lives of the characters. Patsy, falling in love as a teenager, facing the uncertainty of having to leave Dublin to live in England. This tender, amusing, sharp and gloriously sparkling work will appeal to a wide audience who enjoy engaging with the full range of human emotions. Striking, thoughtful, funny; guaranteed to keep you reading – a book to relish.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Thornton
      </h2>
      
      <p class="authorDescription body article">Robert Thornton was born in Dublin in 1944 and grew up and went to school there until the age of 15. He moved to Kent, England, in 1959, where he continued his education part-time between different career choices, including engineering apprenticeship, washing machine salesman, debt collector, military (three years) and eventually, schoolteacher and headmaster. He lives in Somerset with his wife, Veronica.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0537a94e